import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getOnpremHostname } from 'omni-package-react-core';
import Configuration from '../../../utils/Configuration';
import { getLanguage } from '../../../utils/getLanguage';
import { WidgetGlobalStyles } from './SignIn.styles';
import { getSignInConfiguration } from './getSignInConfiguration';

export interface SignInProps {
  mobileDeviceMode: Boolean;
  title: String;
  StyledInstabilityMessagesID: String;
  StyledInformativeMessageID: String;
  StyledTitleId: String;
  disableSignUp?: boolean;
  showRememberMe: boolean;
}

const SignIn: FC<SignInProps> = ({ mobileDeviceMode, title, StyledInstabilityMessagesID, StyledInformativeMessageID, StyledTitleId, disableSignUp = false, showRememberMe }) => {
  const { t } = useTranslation('LoginPageV2');
  const config = getSignInConfiguration(t, mobileDeviceMode, disableSignUp);
  const configApp = Configuration.Current();
  const showRememberMeDisplay = showRememberMe ? 'block' : 'none';

  React.useEffect(() => {
    const innerScript = `
    function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }

          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });

          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
    }


    function SetExperienceAndMobileDeviceMode() {
      let needReload = false;
      const dealersExperiences = {
        ia: 'ia',
        bnt: 'bnt',
        designSystem: 'designSystem',
        investia: 'investia',
        'Extranet Dealers Hyundai - Siteminder': 'hyundai',
        'Extranet Dealers Hyundai Mobile - Siteminder': 'hyundai',
        'Extranet Dealers Unifi - Siteminder': 'uniFi',
        'Extranet Dealers Unifi Mobile - Siteminder': 'uniFi',
        'Extranet Dealers Honda - Siteminder' : 'honda',
        'Extranet Dealers Honda Mobile - Siteminder': 'honda',
        'Extranet Dealers Acura - Siteminder': 'acura',
        'Extranet Dealers Acura Mobile - Siteminder': 'acura',
        'Extranet Dealers Genesis - Siteminder': 'genesis',
        'Extranet Dealers Genesis Mobile - Siteminder': 'genesis',
      };
      const dealersExperience = sessionStorage.getItem('dealersExperience') ;
      if (dealersExperience == null && oktaData.requestContext.app != undefined) {
          const clientLabel = oktaData.requestContext.app.value.label;
          if (dealersExperiences[clientLabel]) {
            sessionStorage.setItem('dealersExperience',dealersExperiences[clientLabel]);
            sessionStorage.setItem('mobileDeviceMode', dealersExperiences[clientLabel].includes('Mobile'));
            needReload = true;            
          }
          else{
            console.log('clientLabel not found',clientLabel);
          }
      }
      return needReload;
    }
    
    var NeedReload = SetExperienceAndMobileDeviceMode();    
    if (NeedReload) {
      location.reload();
    }
    var errorCounter = 0;
    var config = OktaUtil.getSignInWidgetConfig();
    Object.assign(config.i18n, ${JSON.stringify(config.i18n)});
    config.language = "${getLanguage()}";
    Object.assign(config.helpLinks, ${JSON.stringify(config.helpLinks)});
    Object.assign(config.features, ${JSON.stringify(config.features)});
    config.defaultCountryCode = ${JSON.stringify(config.defaultCountryCode)};
    config.customButtons = [
      {
        i18nKey: 'forgotUsername.title',
        className: 'link',
        click: function () {
          window.location.href = "${getOnpremHostname()}${configApp.forgetUserNamePath}";
        }
      },
    ];

    if (config.features.registration) {
      config.customButtons.push({
        i18nKey: 'registration.title',
        className: 'btn-registration',
        click: function () {
          window.location.href = "${getOnpremHostname()}${configApp.registrationPath}";
        }
      });
    }

    config.mobileDeviceMode = ${config.mobileDeviceMode};
    config.useClassicEngine= ${config.useClassicEngine};
    if (oktaSignIn != undefined) {
      oktaSignIn.remove();
    }
    var oktaSignIn = new OktaSignIn(config);
    var oktaSignInCompleteEvent = function (res) {
      if (window.logger) {
        if (res.status === 'SUCCESS') {        
          window.logger.info("Authentication success. Username:" + res.user.profile.login);        
        } else {
          window.logger.error("Authentication returned status: res.status");
        }
      }
      OktaUtil.completeLogin(res);
    }

    var oktaSignInErrorEvent = function (err) {
      if (window.logger) {
          window.logger.info("Authentication returned error:" + error.name + "," + error.message);        
      }
    }

    oktaSignIn.renderEl(
      { el: '#okta-login-container' },
      oktaSignInCompleteEvent,
      oktaSignInErrorEvent
    );
    if (oktaSignIn.options.useClassicEngine) {
      oktaSignIn.before('success-redirect', async () => {
        // custom logic can go here. when the function resolves, execution will continue.
        window.logger.info("Authentication success. Username:" + oktaSignIn.router.appState.attributes.user.identifier);
      });
  }
    oktaSignIn.on('afterError', function (context, error) {
      let controller = "mfa-verify-password";

      // Erreur a l'entrer d'un MFA
      if (error.xhr.responseJSON.errorCode == "E0000069" && context.controller === "mfa-verify") {
        cookieStore.get("urlLogin").then( (response) => {
          window.location.replace( response.value);
        });        
        return;
      }      

      if (error.xhr.responseJSON.errorCode == "E0000011") {
        oktaSignIn.router.appState.attributes.transaction.data.stateToken = "";
      };

      if (oktaSignIn.options.useClassicEngine) { 
        controller ="primary-auth";
      }
      if (context.controller === controller)
      {
        errorCounter += 1;
        if (oktaSignIn.options.useClassicEngine) { 
          document.getElementById("okta-signin-password").value = "";
        }
        if (errorCounter >= 6) {
          waitForElm('.okta-form-infobox-error.infobox.infobox-error').then((elm) => {
            elm.lastChild.innerText = config.i18n[config.language].loginErrorCounter;
          });
        }
      }
    });

    function hideOrShowBasePrimaryAuth (context, isMobile, objID) {
      let controller = "primary-auth";
      if (oktaSignIn.options.useClassicEngine) { 
        controller ="idp-discovery";
      }
          
      var obj = document.getElementById(objID);
      if (obj){
        if ((context.controller === controller && !isMobile))
        {
            obj.style.display = "block";
        }
        else
        {
          obj.style.display = "none";
        }
      }
      return;
    }

    function updateTitle(context) {      
      var StyledTitleId = document.getElementById("${StyledTitleId}");
      if (StyledTitleId) {
        if (context.controller === "idp-discovery")
        {          
          errorCounter = 0;
          StyledTitleId.innerText = "${title}";
          if (oktaSignIn.options.useClassicEngine) {            
            document.getElementsByClassName('o-form-input-name-remember')[0].parentElement.parentElement.style.display='${showRememberMeDisplay}';
            document.getElementsByClassName('primary-auth-container')[0].style.display='block';                   
            document.getElementById('help-links-container').style.display='none';           
            document.querySelectorAll('[data-se="help-link"]')[0].setAttribute('style', 'display: block !important'); 
            document.getElementsByClassName('registration-container')[0].setAttribute('style', 'display: none !important');            
          }

          setStyleAuthHeaderClassicEngine('none');
        }
        else if (context.controller === "primary-auth")
        {
          StyledTitleId.innerText = "${title}";
          if (oktaSignIn.options.useClassicEngine) {            
            document.getElementsByClassName('o-form-input-name-remember')[0].parentElement.parentElement.style.display='${showRememberMeDisplay}';
            document.querySelectorAll('div.registration-container').forEach(function(e) { e.style.display='none' });
            document.getElementById('okta-signin-submit').setAttribute('value',oktaSignIn.options.i18n[oktaSignIn.options.language]['mfa.challenge.verify']);
            document.getElementById('help-links-container').style.display='block';
            document.getElementsByClassName('primary-auth-container')[0].style.display='none';  
            document.querySelectorAll('[data-se="back-link"]').forEach(function(e) { e.setAttribute('style', 'display: block !important') });
            document.querySelectorAll('[data-se="help-link"]').forEach(function(e) { e.setAttribute('style', 'display: none !important') });
            document.getElementsByClassName('registration-container')[0].setAttribute('style', 'display: none !important');
          }

          setStyleAuthHeaderClassicEngine('none');
        }
        else if (context.formName === "select-authenticator-enroll" || context.formName === "select-authenticator-authenticate" || context.controller === "enroll-choices")
        {
          StyledTitleId.innerText = "${t('widgetTitleMultiFacteur')}";
        }
        else if (context.controller === "mfa-verify")
        {
          StyledTitleId.innerText = "${t('widgetTitleMultiFacteur')}";
          setStyleAuthHeaderClassicEngine('block');
        }
        else if (context.authenticatorKey === "okta_verify")
        {
          StyledTitleId.innerText = "${t('widgetTitleOktaVerify')}";
        }
        else if (context.authenticatorKey === "google_otp") {
          StyledTitleId.innerText = "${t('widgetTitleGoogleAuthenticator')}";
        }
        else if (context.controller === "enroll-totp") {
          StyledTitleId.innerText = "${t('widgetTitleAppAuthenticator')}";
        }
        else if (context.authenticatorKey === "phone_number" || typeof context.controller === "function")
        {
          StyledTitleId.innerText = "${t('widgetTitlePhoneAuthenticator')}";
        }
        else if (context.authenticatorKey === "webauthn") {
          StyledTitleId.innerText = "${t('widgetTitleBiometricAuthenticator')}";
        }
        else if (context.authenticatorKey === "okta_password") {
          StyledTitleId.innerText = "${title}";
        }
      }
      return;
    }

    function setStyleAuthHeaderClassicEngine(authHeaderDisplay) { 
      if (oktaSignIn.options.useClassicEngine === true) {
        const authHeader = document.querySelector(".auth-header");
        authHeader.style.display = authHeaderDisplay;

        const oktaSignInHeader = document.querySelector(".okta-sign-in-header");
        oktaSignInHeader.style.borderBottomColor = '#fff';

        const beaconContainer = document.querySelector(".beacon-container");
        beaconContainer.style.top = '-52px';

        const authOrgLogo = document.querySelector(".auth-org-logo");
        authOrgLogo.style.display = 'none';
      }
    }
    
    function setStyleIaPrivateWealth() { 
      if (oktaSignIn.options.useClassicEngine === false) {                       
        const authContentInner = document.querySelector(".auth-content-inner");
        const siwMainViewPrimary = document.querySelector(".siw-main-view.identify.primary-auth");
        const siwMainViewSelect = document.querySelector(".siw-main-view.select-authenticator-authenticate");
        const siwMainViewReenroll = authContentInner.querySelector('.siw-main-view.reenroll-custom-password-expiry--okta_password.custom-password-expired');
        const siwMainViewEnroll = document.querySelector(".siw-main-view.select-authenticator-enroll.enroll-choices");
        const siwMainViewSuccess = document.querySelector(".siw-main-view.success-redirect");

        if (!siwMainViewPrimary && !siwMainViewSelect && !siwMainViewReenroll && !siwMainViewEnroll && !siwMainViewSuccess) {
          authContentInner.style.paddingTop = "120px";
        } else if (siwMainViewPrimary || siwMainViewReenroll || siwMainViewEnroll || siwMainViewSuccess) {
          authContentInner.style.paddingTop = null;
        }
    }
  }

  function setPaddingbackBouton() { 
    if (oktaSignIn.options.useClassicEngine === false) {
      const authContentInner = document.querySelector(".auth-content-inner");
      const switchAuthBtn = document.querySelector(".js-switchAuthenticator");
      if (switchAuthBtn) {
      switchAuthBtn.addEventListener("click", () => {
        authContentInner.style.paddingTop = null;
      });
     }
    }
  }

  function setCookie(name, value, expiration = undefined, domain = undefined, path = "/", addSecure = true)
  {
      var cookieValue = name + "=" + value;

      if (expiration) {
        cookieValue += ";expires=" + expiration;
      }

      if (domain) {
        cookieValue += ";domain=" + domain;
      }
      
      if (path) {
        cookieValue += ";path=" + path;
      }

      if (addSecure) {
        cookieValue += ";secure";
      }

      document.cookie = cookieValue;
  }

    function flushOktaStateToken (context) {
      let controller = "primary-auth";
      if (oktaSignIn.options.useClassicEngine) { 
        controller ="idp-discovery";
      }
      if (context.controller === controller) { 
        const allDomains = [".ia.ca", ".iafg.net", ".inalco.com", ".iagestionprivee.ca", ".iaprivatewealth.ca"];

        let myDate = new Date();
        myDate = new Date(myDate.getTime() + (5*60*1000));
        myDate.setFullYear(myDate.getFullYear() - 1);
        for(const domain of allDomains)
        {
          setCookie("oktaStateToken", "aa", myDate.toUTCString(), domain);
        }
      }
    }
    
    function setOktaStateToken(context) {            
      if (context.controller === "custom-password-expired") {        
        const btnTempPasswordLink = document.getElementsByClassName('button button-primary button-wide link-button')[0];
        if (btnTempPasswordLink != null) {
          btnTempPasswordLink.parentNode.replaceChild(btnTempPasswordLink.cloneNode(true), btnTempPasswordLink);
          const replacedBtnTempPasswordLink = document.getElementsByClassName('button button-primary button-wide link-button')[0];
          replacedBtnTempPasswordLink.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.location.hash = "#/change-password";
          });
        }
        let myDate = new Date();
        console.log(context.controller);
        myDate = new Date(myDate.getTime() + (5*60*1000));
        if (oktaSignIn.options.useClassicEngine) {
          cookieStore.get("oktaStateToken").then( (response) => {            
            document.cookie = "awAccountManagementVersion=v1" + ";expires=" + myDate.toUTCString() + ";domain=.ia.ca;path=/;secure";
            document.cookie = "awAccountManagementVersion=v1" + ";expires=" + myDate.toUTCString() + ";domain=.iafg.net;path=/;secure";
            document.cookie = "awAccountManagementVersion=v1" + ";expires=" + myDate.toUTCString() + ";domain=.inalco.com;path=/;secure";         
          })
        } else {
          const allDomains = [".ia.ca", ".iafg.net", ".inalco.com", ".iagestionprivee.ca", ".iaprivatewealth.ca"];
          const dealersExperienceDomains = [".ia.ca", ".iafg.net", ".inalco.com"];

          for(const domain of allDomains)
          {
            setCookie("oktaStateToken", sessionStorage.getItem("osw-oie-state-handle"), myDate.toUTCString(), domain);
            setCookie("awAccountManagementVersion", "v2", myDate.toUTCString(), domain);
            setCookie("username", oktaSignIn.getUser().identifier, myDate.toUTCString(), domain);
          }
  
          myDate.setFullYear(myDate.getFullYear() +1);

          for(const domain of dealersExperienceDomains)
          {
            setCookie("dealersExperience", sessionStorage.dealersExperience, myDate.toUTCString(), domain);
          }
        }
      }
    }

    var observer = undefined;
    var observerConfig = { attributes: true } ;
    var observerCallback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes") {
          if (mutation.attributeName === "disabled"){
            if (mutation.target.attributes.getNamedItem("disabled") === null) {
              document.getElementById("okta-signin-username").disabled = true;
            }
          }
        }
      }
    };

    oktaSignIn.on('afterRender', function (context) {
      console.log("afterRender");
      hideOrShowBasePrimaryAuth(context, config.mobileDeviceMode, "${StyledInstabilityMessagesID}");
      hideOrShowBasePrimaryAuth(context, config.mobileDeviceMode, "${StyledInformativeMessageID}");      
      updateTitle(context);
      flushOktaStateToken(context);
      setOktaStateToken(context);      
      if  ("${configApp.businessEntityCode}" ==="14") {
        setStyleIaPrivateWealth();
        setPaddingbackBouton();
      }
      if (oktaSignIn.options.useClassicEngine && context.controller === "primary-auth") {
        const targetNode = document.getElementById("okta-signin-username");
        observer = new MutationObserver(observerCallback);
        observer.observe(targetNode, observerConfig);
      }
      else if ( observer != undefined) 
      {
        observer.disconnect();
      }
      
      return;
    });
    var domain = "." + document.location.host.split('.').slice(-2).join('.');
    if ( oktaSignIn.options.useClassicEngine) {
      if (!document.location.href.includes("oauth2")) 
      {
        document.cookie="urlLogin=" + document.location.href + "; expires=Session; path=/;domain=" + domain + ";secure=true;"    
      };
    } else {
      document.cookie="urlLogin=" + document.location.href + "; expires=Session; path=/;domain=" + domain + ";secure=true;"    
    }
    `;
    const externalScript = document.createElement('script');
    externalScript.id = 'ExternalScriptForOktaLogin';
    externalScript.innerHTML = innerScript;
    externalScript.async = true;
    externalScript.type = 'text/javascript';
    document.body.append(externalScript);

    return () => {
      externalScript.remove();
    };
  }, [config, configApp, StyledInformativeMessageID, StyledInstabilityMessagesID, StyledTitleId, t, title, showRememberMeDisplay]);

  return (
    <>
      <WidgetGlobalStyles />
      <div id="okta-login-container"></div>
    </>
  );
};

export default SignIn;
